import store from '@/store'

export const getAnnualReportName = body =>
  `Итоговый отчет за ${getYearById(body.yearId)} г. ${getDepartmentByListId(body.departmentsId)}.xlsx`

export const getReportForWorkName = (body, employeeName) =>
  `ЭК_${getPeriodById(body.periodId)}. ${getReportTarget(body, employeeName)}.xlsx`

const getYearById = yearId => store.getters['dictionaries/yearList'].find(el => el.id === yearId)?.year
const getDepartmentById = depId => store.getters['dictionaries/departmentList'].find(el => el.id === depId)?.name
const getDepartmentByListId = listId => (listId.length > 1 ? 'по кафедрам' : getDepartmentById(listId[0]))
const getPeriodById = periodId => {
  const currentPeriod = store.getters['dictionaries/periodList'].find(el => el.id === periodId)
  return `${currentPeriod.quarter.quarterNum}_${currentPeriod.year.year}`
}
const getReportTarget = (body, employeeName) =>
  employeeName ? employeeName : getDepartmentByListId(body.departmentsId)
